import { getModel } from '../../model/registry'
import styled from 'styled-components'
import { useRef, useState, useEffect } from 'react'
import { useTheme } from 'styled-components'
import useOutsideClick from '../../hooks/useOutsideClick'

import useSidebar from '../../hooks/useSidebar'
import { useSnapshot } from 'valtio'

//Import Sub-Components
import SBSubMenu from './SBSubMenu'
import visibleNavItems from './visibleNavItems'
import useScreenSize from '../../hooks/useScreenSize'

//Importing Icons to use
import * as AiIcons from 'react-icons/ai'
import appLogo from '../../assets/logo'

//Import utilities for the URL
import { useLocation } from 'react-router-dom'
import extractSlug from '../../utils/extractSlug'

import { NavIconColor } from '../../styles/IconStyle'

const SideBarNav = styled.nav`
    background: ${({ theme }) => theme.nav.background};
    width: 15rem;
    display: 'flex';
    justify-content: center;
    transition: 350ms;
    z-index: 1001;
    @media (max-width: ${({ theme }) => theme.breakpoint.s}) {
    border-right: 2px solid ${({ theme }) => theme.area.border}
  }
    `

const MenuItemsWrap = styled.div`
    width: 100%;
    /*padding-left: calc(var(--bs-gutter-x) * .5);*/

    @media (max-width: 768px) {
    padding-left: 0;
  }
`

const SideBarWrapper = styled.div`
    position: relative;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: ${({ $visible }) => ($visible ? '15rem' : '0')};
    overflow: hidden;
    background-color: ${({ theme }) => theme.nav.background};
    min-height: 100vh !important;
    transition: width 300ms ease;

    @media (max-width: ${({ theme }) => theme.breakpoint.s}) {
    position: fixed;
    top: -60px;
    bottom: 0;
    left: 0;
    width: 15rem;
    overflow: visible;
    border-right: 2px solid ${({ theme }) => theme.area.border};
    transform: ${({ $visible }) => ($visible ? 'translateX(0)' : 'translateX(-100%)')};
    transition: transform 300ms ease;
  }
    `

const SidebarContentWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 15rem;
    height: 100%;
    overflow: hidden;
`

const SidebaContent = styled.div`
    /* Apply desired styles */
    height: 100%;
    overflow: auto; /* Enable scrolling */
`

const SideBarTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    font-size: 1.35rem;
    color: ${({ theme }) => theme.nav.font};
    padding-inline: 1rem;
    margin-block: 1rem;
`
const SideBarCloseBar = styled.div`
    font-size: 1.5rem;
    justify-content: flex-end;
    display: none;

    @media (max-width: 768px) {
    display: flex;
    padding-top: 60px;
  }
`

const SideBarCloseButton = styled.div`
    padding: 0.5rem;
    position: absolute;
    right:0;
`

const homeNav = {
    title: 'Home',
    path: '/home',
    icon: <AiIcons.AiFillHome />
}

const Sidebar = () => {
    const path = useLocation()
    const location = extractSlug(path.pathname).toUpperCase()
    const key = location.toLowerCase()
    const { isMobile: onPhone } = useScreenSize()
    const data = getModel('sidebarData')[key] && visibleNavItems(getModel('sidebarData')[key], onPhone)

    const theme = useTheme()
    const { toggleSidebar, sbState } = useSidebar()
    const snap = useSnapshot(sbState)
    const sidebarVisibility = snap.visible

    const isMobile = () => window.getComputedStyle(document.getElementById('sideBarWrapper')).position === 'fixed'

    useEffect(() => {
        if (!isMobile()) return

        const meta = document.querySelector('meta[name="theme-color"]')
        if (sidebarVisibility) {
            document.body.style.overflow = 'hidden'
            if (meta) meta.setAttribute('content', theme.nav.background)
        } else {
            document.body.style.overflow = ''
            if (meta) meta.setAttribute('content', theme.nav.background)
        }

        return () => { document.body.style.overflow = '' }
    }, [sidebarVisibility, theme])

    const handleOutsideClick = (e) => {
        toggleSidebar()
    }

    const closeSideBarOnMobile = (e) => {
        let element = document.getElementById('sideBarWrapper')
        let position = window.getComputedStyle(element, null).position
        // Closes the sidebar on Mobile
        if (position === 'fixed') {
            toggleSidebar()
        }
    }

    //Handle Click Outside the Object
    const myRef = useRef(null);
    useOutsideClick(myRef, handleOutsideClick, 'sidebar');

    return (
        <>
            <SideBarWrapper ref={myRef} id="sideBarWrapper" $visible={sidebarVisibility}>
                <SidebarContentWrapper>
                    <SidebaContent>
                        <NavIconColor>
                            <SideBarCloseBar>
                                <SideBarCloseButton onClick={toggleSidebar}><AiIcons.AiOutlineClose /></SideBarCloseButton>
                            </SideBarCloseBar>
                            <SideBarTitle id="SideBarTitle">
                                {appLogo}
                                {/* <AiIcons.AiFillAppstore /> */}
                                <span>{location}</span>
                            </SideBarTitle>
                        </NavIconColor>
                        <NavIconColor >
                            <SideBarNav>
                                <MenuItemsWrap >
                                    {
                                        data ?
                                            data.map(
                                                (item, index) => {
                                                    return <SBSubMenu item={item} key={index} handleClick={closeSideBarOnMobile} />
                                                }
                                            )
                                            : <SBSubMenu item={homeNav} key="1" />
                                    }
                                </MenuItemsWrap>
                            </SideBarNav>
                        </NavIconColor>

                    </SidebaContent>
                </SidebarContentWrapper>
            </SideBarWrapper>
        </>
    )
}

export default Sidebar